import { render, staticRenderFns } from "./TicketRomana.vue?vue&type=template&id=ddd921d2&"
import script from "./TicketRomana.vue?vue&type=script&lang=js&"
export * from "./TicketRomana.vue?vue&type=script&lang=js&"
import style0 from "./TicketRomana.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports